import { useStore } from '@/app/store';
import './footer.css';
import { NavItem } from '@/widgets/layout/navbar/Navbar';
import { useTranslation } from 'react-i18next';
import telegramImg from '@/assets/images/telegram.svg';
import watsAppImg from '@/assets/images/watsApp.svg';
import whiteTelegramImg from '@/assets/images/whiteTelegram.svg';
import logoImg from '@/assets/images/logo.svg';
import { observer } from 'mobx-react-lite';
import { brandConfig, brandLinks } from '@/shared/config/brand';
import { Link } from 'react-router-dom';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const store = useStore();
  const footerPhones =
    brandConfig.phones.length > 0
      ? brandConfig.phones
      : brandConfig.phone
        ? [{ label: '', value: brandConfig.phone, href: brandConfig.phone }]
        : [];

  return (
    <footer className='footer-section'>
      <div className='footer-container'>
        <div className='footer-content'>
          <div className='footer-topline'>
            <div className='footer-logo' aria-label={brandConfig.name}>
              <img
                src={logoImg}
                alt=''
                className='footer-logo__mark'
                width='72'
                height='72'
              />
              <div className='footer-logo__text'>
                <span>{brandConfig.name}</span>
                <small>BY DIMMAREX</small>
              </div>
            </div>
            <div className='social-items'>
              <a
                href={brandLinks.telegramOperator}
                target='_blank'
                rel='noreferrer'
                className='social-button social-button-icon'
                aria-label='Telegram'
              >
                <img src={telegramImg} alt='' width='50' height='50' />
              </a>
              {brandLinks.whatsapp && (
                <a
                  href={brandLinks.whatsapp}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='social-button social-button-icon'
                  aria-label='WhatsApp'
                >
                  <img src={watsAppImg} alt='' width='50' height='50' />
                </a>
              )}
            </div>
            <div className='social-items social-channel-items'>
              <a
                href={brandLinks.telegramChannel}
                target='_blank'
                rel='noreferrer'
                className='social-item'
              >
                <img src={whiteTelegramImg} alt='' width='50' height='50' />
                {t('contacts.ourTelegramChannel')}
              </a>
              {store.viewTgBot && (
                <a
                  href={brandLinks.telegramBot}
                  target='_blank'
                  rel='noreferrer'
                  className='social-item'
                >
                  <img src={whiteTelegramImg} alt='' width='50' height='50' />
                  {t('contacts.ourTelegramBot')}
                </a>
              )}
            </div>
          </div>
          <div className='footer-cta-grid'>
            {footerPhones.length > 0 && (
              <div className='single-cta'>
                <i className='fas fa-phone-volume'></i>
                <div className='cta-text'>
                  <h4>{t('footer.callUs')}</h4>
                  <div className='footer-phone-list'>
                    {footerPhones.map((phone) => (
                      <a href={`tel:${phone.href}`} key={phone.href}>
                        {phone.label && <span>{phone.label}: </span>}
                        {phone.value}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            )}
            <div className='single-cta'>
              <i className='far fa-envelope-open'></i>
              <div className='cta-text'>
                <h4>{t('footer.mail')}</h4>
                <a href={brandLinks.email}>{brandConfig.email}</a>
              </div>
            </div>
            <div className='single-cta'>
              <i className='fas fa-map-marker-alt'></i>
              <div className='cta-text'>
                <h3>{t('footer.address')}</h3>
                <address>
                  <div>{brandConfig.office.address}</div>
                </address>
              </div>
            </div>
          </div>
          <div className='footer-bottom'>
            <div className='footer-legal'>
              <div className='footer-legal-line'>
                <Link to='/politica'>{t('navbar.privacyPolicy')}</Link>
                <span>
                  {brandConfig.legalName} {t('footer.inn')} {brandConfig.inn}
                </span>
              </div>
              <p>
                {t('footer.copyright')}&copy;{t('footer.definde')}
              </p>
            </div>
            <nav className='footer-menu' aria-label={t('navbar.siteMap')}>
              <ul>
                <NavItem to='/'>{t('navbar.home')}</NavItem>
                <NavItem to='/invoice'>{t('navbar.invoice')}</NavItem>
                <NavItem to='/partnership'>{t('navbar.partnership')}</NavItem>
                <NavItem to='/usdt-rates'>{t('navbar.usdtRates')}</NavItem>
                <NavItem to='/kyc'>{t('navbar.kyc')}</NavItem>
                <NavItem to='/reviews'>{t('navbar.reviews')}</NavItem>
                <NavItem to='/contacts'>{t('navbar.contacts')}</NavItem>
                <NavItem to='/rules'>{t('navbar.rules')}</NavItem>
                <NavItem to='/articles'>{t('navbar.articles')}</NavItem>
                <NavItem to='/site-map'>{t('navbar.siteMap')}</NavItem>
                {i18n.language === 'ru' && (
                  <NavItem to='/learning-materials'>
                    {t('navbar.learningMaterials')}
                  </NavItem>
                )}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default observer(Footer);
